export class SortModel {
  column: string;
  sort: string;
}
